import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root',
})
export class ClientService extends BaseService {
    serviceCode = 'UserOrg';
    entityName = 'Client';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getDetailByGuid(id: string) {
        const url = `${this.serviceUri}/ByGuidClaim/${id}`;
        return this.defaultGet(url);
    }
}
